import {Image} from '@shopify/hydrogen';
import LogoLockup from './LogoLockup.client';
import {useEffect, useRef, useState} from 'react';
import Cookies from 'js-cookie';
import {motion} from 'framer-motion';
export default function CoverImage({src}: any) {
  const timer = useRef(null);
  const [isShown, setIsShown] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [cookieFound, setCookeFound] = useState(null);

  useEffect(() => {

    if (Cookies.get('coverImage') === undefined) {
      setIsShown(true);
      setCookeFound(false);
      timer.current = setTimeout(() => {
        setIsShown(false);
        Cookies.set('coverImage', 'false');
      }, 3000);
    } else {
      setCookeFound(true);
      setIsShown(false);
    }
  }, [loaded]);

  useEffect(() => {
    setMounted(true);
  })

  const onClick = () => {
    console.log('clicked');
    clearTimeout(timer.current);
    Cookies.set('coverImage', 'true');
    setIsShown(false);
  };

  const onLoad = () => {
    console.log('loaded');
  };



  if(!mounted || !isShown) return null;
  return (
    <motion.div
      onClick={onClick}
      className={`fixed top-0 left-0 bottom-0 bg-white right-0 h-full w-full z-50 flex items-center justify-center`}
      animate={{ transform: 'translateY(-100%)' }}
      transition={{ duration: 2, delay: 2 }}
    >
      <div className="max-w-2xl w-full fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
        <LogoLockup />
      </div>
      {src && (
        <Image
          src={src}
          width="100%"
          alt="Gauntlett Cheng"
          height="100%"
          onLoad={onLoad}
          className="object-cover absolute top-0 left-0 h-full w-full"
        />
      )}
    </motion.div>
  );
}
